import { selectSelectedInterviewApplicant } from '../../../../../store/workspace/selectors';
import { setRecruitingInterviewReportModal } from '../../../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import { CheckListSquareIcon } from '../../../../../assets/icons';
import Modal from '../../../../../components/Modal';
import ResultIcon from '../../components/ResultIcon';
import styles from './style.module.scss';

export default function RecruitingInterviewReport() {
    const dispatch = useDispatch();
    const reportData = useSelector(selectSelectedInterviewApplicant);

    const closeModal = () => dispatch(setRecruitingInterviewReportModal(false));

    return (
        <Modal
            size='xxl'
            actions='dismiss'
            restrictActionsWidth
            closeFunc={closeModal}
            title='Criteria explanation'
            icon={<CheckListSquareIcon />}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Close',
                type: 'Outline-Dark',
                onClick: closeModal,
            }}
        >
            <div className={styles.status}>
                <span>{reportData?.result}</span>
                <ResultIcon result={reportData?.result} />
            </div>
            <p className={styles.report}>
                {reportData?.reason}
            </p>
        </Modal>
    );
};
